// ✅ GRAFT COUNTER – A4 FINAL CENTERED NAME VERSION

import { jsPDF } from "jspdf";
import { Canvg } from "canvg";

//
// A4 sayfa ölçüleri (pt)
//
const A4_W = 595;
const A4_H = 842;

//
// Canva → A4 ölçek
//
const SCALE_X = A4_W / 1240;
const SCALE_Y = A4_H / 1754;

//
// Baseline düzeltme (Canva y-top → jsPDF y-baseline)
//
const baselineY = (yTopPx, fontPt) => yTopPx * SCALE_Y + fontPt * 0.85;

// Canva’dan gelen konumlar (px)
const POS = {
  page1: { name: { yTop: 1302, fontPt: 18 } },
  page3: { graft: { x: 470, yTop: 1522, fontPt: 24 } },
  page4: {
    high: { xRight: 785, yTop: 1476, fontPt: 24 },
    low: { xRight: 785, yTop: 1601, fontPt: 24 },
  },
};

// ---------------- HELPERS ----------------

async function loadSvg(name) {
  const res = await fetch(`/report/${name}`, { cache: "no-store" });
  return res.text();
}

function replaceImg(svg, data) {
  return svg
    .replace(/xlink:href="data:image[^"]*"/, `xlink:href="${data}"`)
    .replace(/href="data:image[^"]*"/, `href="${data}"`);
}

async function toDataURL(url) {
  const res = await fetch(url, { mode: "cors" });
  const blob = await res.blob();
  return new Promise((resolve) => {
    const fr = new FileReader();
    fr.onloadend = () => resolve(fr.result);
    fr.readAsDataURL(blob);
  });
}

async function svgToPng(svg) {
  const canvas = document.createElement("canvas");
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext("2d");
  const v = await Canvg.from(ctx, svg);
  await v.render();
  return canvas.toDataURL("image/png", 0.95);
}

const fmt = (v) =>
  v == null || isNaN(v) ? "-" : Number(v).toFixed(2);

// ---------------- MAIN ----------------

export async function buildPdfReport({
  patientName,
  graftCount,
  highDensityPercent,
  lowDensityPercent,
  overlayUrl,
  heatmapUrl,
  filename = "GraftCounter_Report.pdf",
}) {
  console.log("📄 PDF A4 Oluşturuluyor...");

  const [overlay, heatmap] = await Promise.all([
    toDataURL(overlayUrl),
    toDataURL(heatmapUrl),
  ]);

  const [s1, s2, s3raw, s4raw, s5, s6, s7] = await Promise.all([
    loadSvg("1.svg"),
    loadSvg("2.svg"),
    loadSvg("3.svg"),
    loadSvg("4.svg"),
    loadSvg("5.svg"),
    loadSvg("6.svg"),
    loadSvg("7.svg"),
  ]);

  const s3 = replaceImg(s3raw, overlay);
  const s4 = replaceImg(s4raw, heatmap);

  const [p1, p2, p3, p4, p5, p6, p7] = await Promise.all([
    svgToPng(s1),
    svgToPng(s2),
    svgToPng(s3),
    svgToPng(s4),
    svgToPng(s5),
    svgToPng(s6),
    svgToPng(s7),
  ]);

  const doc = new jsPDF({
    unit: "pt",
    format: "a4",
    orientation: "portrait",
    compress: true,
  });

  const pages = [p1, p2, p3, p4, p5, p6, p7];
  pages.forEach((img, i) => {
    if (i > 0) doc.addPage("a4");
    doc.addImage(img, "PNG", 0, 0, A4_W, A4_H);
  });

  // ✅ METİN EKLEME — EN ÜST KATMAN
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);

  // Page 1 → Patient Name (CENTER + UPPERCASE)
  doc.setPage(1);
  doc.setFontSize(POS.page1.name.fontPt);
  doc.text(
    (patientName || "UNKNOWN").toUpperCase(),
    A4_W / 2,
    baselineY(POS.page1.name.yTop, POS.page1.name.fontPt),
    { align: "center" }
  );

  // Page 3 → Graft Count
  doc.setPage(3);
  doc.setFontSize(POS.page3.graft.fontPt);
  doc.text(
    `${graftCount ?? 0}`,
    POS.page3.graft.x * SCALE_X,
    baselineY(POS.page3.graft.yTop, POS.page3.graft.fontPt)
  );

  // Page 4 → High / Low Density
  doc.setPage(4);
  doc.setFontSize(POS.page4.high.fontPt);

  doc.text(
    `${fmt(highDensityPercent)}%`,
    POS.page4.high.xRight * SCALE_X,
    baselineY(POS.page4.high.yTop, POS.page4.high.fontPt),
    { align: "right" }
  );

  doc.text(
    `${fmt(lowDensityPercent)}%`,
    POS.page4.low.xRight * SCALE_X,
    baselineY(POS.page4.low.yTop, POS.page4.low.fontPt),
    { align: "right" }
  );

  doc.save(filename);
  console.log("✅ A4 PDF başarıyla indirildi!");
}
